import { Dynamic } from './Dynamic';

export const HeroDynamic = () => (
    <>
        <Dynamic componentKey="Hero" />
    </>
);
